import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import {
  AUTH_SESSION_UPDATED,
  AUTH_SESSION_EXPIRED,
  scheduleProactiveTokenRefresh,
  cancelProactiveTokenRefresh,
} from '../authAxios.js';

// Crear el contexto
export const LoginContext = createContext();

// Proveedor del contexto
export const LoginProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) {
      return null;
    }
    try {
      const parsedUser = JSON.parse(storedUser);
      if (parsedUser?.token) {
        axios.defaults.headers.common.Authorization = `Bearer ${parsedUser.token}`;
      }
      return parsedUser;
    } catch (error) {
      localStorage.removeItem('user');
      return null;
    }
  });

  const logout = useCallback(() => {
    cancelProactiveTokenRefresh();
    setUser(null);
    localStorage.removeItem('user');
    delete axios.defaults.headers.common.Authorization;
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    if (userData?.token) {
      axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`;
    }
  };

  useEffect(() => {
    const onUpdated = (e) => {
      const next = e.detail;
      if (next && typeof next === 'object') {
        setUser(next);
        if (next.token) {
          axios.defaults.headers.common.Authorization = `Bearer ${next.token}`;
        }
      }
    };
    const onExpired = () => {
      logout();
    };
    window.addEventListener(AUTH_SESSION_UPDATED, onUpdated);
    window.addEventListener(AUTH_SESSION_EXPIRED, onExpired);
    return () => {
      window.removeEventListener(AUTH_SESSION_UPDATED, onUpdated);
      window.removeEventListener(AUTH_SESSION_EXPIRED, onExpired);
    };
  }, [logout]);

  useEffect(() => {
    if (user?.token && user?.refreshToken) {
      scheduleProactiveTokenRefresh();
    } else {
      cancelProactiveTokenRefresh();
    }
    return () => cancelProactiveTokenRefresh();
  }, [user?.token, user?.refreshToken]);

  // Chequea si el usuario está logueado
  const isAuthenticated = !!user;

  return (
    <LoginContext.Provider value={{ user, login, logout, isAuthenticated }}>
      {children}
    </LoginContext.Provider>
  );
};
